import { store } from '@/_store'
import { refreshBrandToken } from '../_service/http-client'
import { authActions } from '../_store/auth/auth.slice'

export function getUser() {
  return store.getState().auth.user
}
export function getSettings() {
  return store.getState().settings.data
}
export function getSession() {
  return store.getState().session
}
export function getUTM() {
  return store.getState().utm
}
export function getCurrency() {
  return store.getState().settings?.country?.currency
}

/**
 * Get the appropriate auth token for API requests
 * @param shipperId - Optional brand/shipper ID for brand-specific token
 * @returns Brand-specific token if available, otherwise global user token
 */
export async function getAuthToken(shipperId?: string | null) {
  const state = store.getState()

  // If shipperId provided, try to get brand-specific token
  if (shipperId) {
    const brandToken = state.auth.tokens[shipperId]?.access_token
    if (brandToken) {
      return brandToken
    } else if (state.auth.user?.access_token) {
      try {
        const data = await refreshBrandToken(shipperId, state.auth.user?.access_token)

        if (data?.access_token) {
          store.dispatch(
            authActions.setBrandToken({
              shipperId: shipperId,
              access_token: data.access_token,
              refresh_token: data.refresh_token,
              client_id: data.id,
            })
          )
        }

        return data?.access_token
      } catch (error) {
        console.log(error)
      }
    }
  }

  // Fall back to global user token
  return state.auth.user?.access_token
}

/**
 * Get the brand token data including refresh token
 * @param shipperId - Brand/shipper ID
 * @returns Token data object or undefined
 */
export function getBrandTokenData(shipperId: string) {
  const state = store.getState()
  return state.auth.tokens[shipperId]
}
